"use client";

import Image from "next/image";
import axios from "axios";
import { useEffect, useState } from "react";

export default function Offering() {
  const [verticals, setVerticals] = useState([]);

  useEffect(() => {
    async function getVerticals() {
      try {
        const res = await axios.get(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}/gitartha/verticals`
        );

        setVerticals(res.data.data);
      } catch (error) {
        console.error("Failed to fetch verticals:", error);
      }
    }

    getVerticals();
  }, []);

  return (
    <section className="w-full bg-white py-8 lg:py-12">
      <div className="max-w-[1120px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <h2 className="text-center font-[BOOWIE] font-medium text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-8 lg:mb-12 bg-gradient-to-r from-[#023753] via-[#0E3147] to-[#0E1015] bg-clip-text text-transparent">
          OUR OFFERINGS!
        </h2>

        {/* Cards */}
        <div className=" grid grid-cols-2 sm:grid-cols-[180px_180px] md:grid-cols-[210px_210px] lg:grid-cols-2 justify-center gap-4 sm:gap-5 md:gap-6 lg:gap-8 xl:gap-10 2xl:gap-12 " >
          {verticals.map((item) => (
            <a
              key={item._id}
              href={item.web_url}
              target="_blank"
              rel="noopener noreferrer"
              className="
                group
                w-full
                sm:w-[180px]
                md:w-[210px]
                lg:w-full
                xl:w-full
                2xl:w-full

                h-[150px]
                sm:h-[180px]
                md:h-[210px]
                lg:h-[240px]
                xl:h-[280px]
                2xl:h-[300px]

                rounded-2xl
                lg:rounded-[28px]

                bg-gradient-to-r
                from-[#023753]
                via-[#0E3147]
                to-[#0E1015]

                flex
                flex-col
                items-center
                justify-center
                gap-0.5

                p-1.5
                sm:p-2
                md:p-2.5
                lg:p-3

                text-center
                text-white

                shadow-lg
                transition-all
                duration-300
                hover:-translate-y-2
                hover:shadow-2xl
              "
            >
              {/* Icon */}
              <Image
                src={`${process.env.NEXT_PUBLIC_FILE_URL}/${item.image}`}
                alt={item.name}
                width={180}
                height={180}
                className="
                  w-20
                  sm:w-24
                  md:w-26
                  lg:w-32
                  xl:w-37
                  2xl:w-[120px]
                  h-auto
                  object-contain
                  transition-transform
                  duration-300
                  group-hover:scale-110
                "
              />

              {/* Title */}
              <h3
                className="
                  mt-0.5
                  font-[BOOWIE]
                  uppercase
                  leading-tight

                  text-sm
                  sm:text-base
                  md:text-lg
                  lg:text-xl
                  xl:text-2xl
                "
              >
                {item.name}
              </h3>

              {/* Description */}
              <p
                className="
                  hidden
                  lg:block

                  mt-0.5
                  max-w-[92%]

                  text-[11px]
                  xl:text-xs

                  leading-4
                  opacity-90
                "
              >
                {item.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}